"use client";

import { useTranslation } from "react-i18next";
import { Building2, Mail } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MicrosoftLoginButtonWithMsal } from "@/components/MicrosoftLoginButton";
import { isMsalConfigured } from "@/auth/msalConfig";

interface LoginModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export default function LoginModal({ open, onOpenChange }: LoginModalProps) {
  const { t } = useTranslation();

  const handleEmailPassword = () => {
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{String(t("auth.title"))}</DialogTitle>
          <DialogDescription>{String(t("auth.subtitle"))}</DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 py-2">
          {isMsalConfigured ? (
            <MicrosoftLoginButtonWithMsal onClose={() => onOpenChange(false)} />
          ) : (
            <Button
              variant="outline"
              className="h-12 justify-start gap-3 text-left"
              disabled
            >
              <Building2 className="h-5 w-5 shrink-0 text-primary" />
              <span>{String(t("auth.microsoft365"))}</span>
              <span className="ml-auto text-xs text-muted-foreground">
                {String(t("auth.configureMsal"))}
              </span>
            </Button>
          )}
          <Button
            variant="outline"
            className="h-12 justify-start gap-3 text-left"
            onClick={handleEmailPassword}
            disabled
          >
            <Mail className="h-5 w-5 shrink-0 text-muted-foreground" />
            <span>{String(t("auth.emailPassword"))}</span>
            <span className="ml-auto text-xs text-muted-foreground">
              {String(t("auth.comingSoon"))}
            </span>
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
